import createPollMoreMethods from './create_poll_more_methods';
import Swal from 'sweetalert2';
import { append_active_organization_id, get_active_organization_id } from '@/utils/organization_profile';

export default {
filter_polls() {
            const portal_id = this.$route.params.portal_id ? Number(this.$route.params.portal_id) : null;
            const endpoint = get_active_organization_id() ? 'get_organization_polls' : 'filter_poll';

            $.ajax({
                url: `${process.env.VUE_APP_BACKEND_API_URL}/survey_management/${endpoint}/`,
                method: 'POST',
                headers: this.get_json_headers(),
                data: JSON.stringify(append_active_organization_id({ portal_id })),
                success: (response) => this.handle_filter_polls_success(response),
                complete: () => {
                    this.isLoading = false;
                }
            });
        },
get_json_headers() {
            return ({
                Authorization: `Token ${this.getToken()}`,
                'Content-Type': 'application/json'
            });
        },
handle_filter_polls_success(response) {
            this.destroy_poll_table();
            this.polls = response.data || [];
            this.poll_dashboard = response.dashboard || {};
            this.refresh_poll_table();
        },
on_input(index) {
            if (!this.should_add_poll_option(index)) return;

            this.options.push({ value: '' });
        },
should_add_poll_option(index) {
            const lastIndex = this.options.length - 1;
            return index === lastIndex && Boolean(this.get_poll_option_value(lastIndex));
        },
get_poll_option_value(index) {
            const lastOption = Reflect.get(this.options, index) || {};
            return String(Reflect.get(lastOption, 'value') || '').trim();
        },
validation_for_poll_name() {
            this.errors = {};
            this.get_poll_validation_rules()
                .filter(rule => rule.invalid())
                .forEach(rule => {
                    Reflect.set(this.errors, rule.field, rule.message);
                });

            return !Object.keys(this.errors).length;
        },
get_poll_validation_rules() {
            return [
                {
                    field: 'poll_name',
                    invalid: () => !String(this.poll_name || '').trim(),
                    message: 'Poll name is required'
                },
                {
                    field: 'poll_question',
                    invalid: () => !String(this.poll_question || '').trim(),
                    message: 'A question is required'
                },
                {
                    field: 'poll_answer',
                    invalid: () => !this.get_poll_answers().length,
                    message: 'At least one answer option is required'
                }
            ];
        },
get_poll_answers() {
            return this.options
                .map((option, index) => ({ text: option.value?.trim(), order: index + 1 }))
                .filter(answer => answer.text);
        },
submit_poll_form() {
            if (!this.validation_for_poll_name()) return;

            $.ajax({
                url: `${process.env.VUE_APP_BACKEND_API_URL}/survey_management/create_poll/`,
                method: "POST",
                headers: this.get_json_headers(),
                data: JSON.stringify(this.build_create_poll_payload()),
                success: () => this.handle_create_poll_success(),
                error: (xhr) => this.handle_create_poll_error(xhr)
            });
        },
build_create_poll_payload() {
            return append_active_organization_id({
                poll_name: this.poll_name,
                description: this.poll_description || '',
                ...this.get_poll_portal_payload(),
                questions: [this.build_poll_question_payload()]
            });
        },
get_poll_portal_payload() {
            return this.$route.params.portal_id
                ? { portal_id: Number(this.$route.params.portal_id) }
                : {};
        },
build_poll_question_payload() {
            return ({
                question_text: this.poll_question,
                question_type: this.allowMultiple ? "selection" : "checkbox",
                options: this.get_poll_answers()
            });
        },
handle_create_poll_success() {
            this.show_poll_success_message('Poll Created', 'Your poll has been successfully created!')
                .then(() => {
                    this.reset_poll_form();
                    this.activeVoiceTab = 'polls';
                    $('#create_poll').modal('hide');
                });
            this.filter_polls();
        },
handle_create_poll_error(xhr) {
            this.errors.poll_name = xhr.responseJSON?.message || 'Unable to create poll.';
        },
show_poll_success_message(title, text) {
            return Swal.fire({
                icon: 'success',
                title,
                text,
                showConfirmButton: false,
                timer: 2000,
                position: 'bottom-end',
                toast: true
            });
        },
reset_poll_form() {
            this.poll_id = null;
            this.poll_name = "";
            this.poll_question = "";
            this.poll_description = "";
            this.allowMultiple = false;
            this.options = [{ value: "" }, { value: "" }, { value: "" }];
            this.errors = {};
            this.isEditMode = false;
        },
cancelEditPoll() {
            this.reset_poll_form();
            $('#create_poll').modal('hide');
        },
update_poll() {
            this.poll_description = this.get_normalized_poll_description();

            if (!this.should_add_question_before_update()) {
                this.update_poll_form();
                return;
            }

            this.add_question_to_poll()
                .then(() => this.update_poll_form())
                .catch((error) => {
                    console.error("Error adding question:", error);
                });
        },
get_normalized_poll_description() {
            const poll_description_text = this.get_poll_description_text();
            return poll_description_text
                .replace(/<\/?p>/g, '')
                .replace(/<br\s*\/?>/gi, '')
                .trim();
        },
get_poll_description_text() {
            const editor_text = this.$refs.quillPollEditorRef?.getText?.();
            const values = [
                editor_text,
                this.poll_description,
                this.description,
                ''
            ];
            return String(values.find(Boolean) || '');
        },
should_add_question_before_update() {
            return Boolean(this.newQuestion.text && this.newQuestion.type);
        },
update_poll_form() {
            Swal.fire({
                title: 'Updating poll...',
                allowOutsideClick: false,
                didOpen: () => Swal.showLoading()
            });

            $.ajax({
                url: `${process.env.VUE_APP_BACKEND_API_URL}/survey_management/update_poll/`,
                method: "POST",
                headers: this.get_json_headers(),
                data: JSON.stringify(this.build_update_poll_payload()),
                success: () => this.handle_update_poll_success(),
                error: (xhr) => this.handle_update_poll_error(xhr)
            });
        },
build_update_poll_payload() {
            return ({
                poll_id: this.poll_id,
                name: this.poll_name,
                description: this.poll_description || '',
                questions: [this.build_update_poll_question_payload()]
            });
        },
build_update_poll_question_payload() {
            return ({
                question: this.poll_question,
                question_type: this.get_poll_question_type_id(),
                question_number: 1,
                is_mandatory: false,
                options: this.get_poll_answers().map(answer => answer.text)
            });
        },
get_poll_question_type_id() {
            const selected_type = this.allowMultiple ? 'selection' : 'checkbox';
            const question_type = this.question_types.find(type =>
                String(type.question_type).toLowerCase() === selected_type
            );

            return question_type?.id || null;
        },
handle_update_poll_success() {
            this.filter_polls();
            this.show_poll_success_message('Poll Updated', 'Your poll has been successfully updated!')
                .then(() => {
                    this.reset_poll_form();
                    this.activeVoiceTab = 'polls';
                });
        },
handle_update_poll_error(xhr) {
            Swal.fire({
                icon: 'error',
                title: 'Cannot Edit Poll',
                text: xhr.responseJSON?.message || 'Poll already answered or invalid data.',
                position: 'bottom-end',
                showConfirmButton: false,
                timer: 3000,
                toast: true
            });
        },
  ...createPollMoreMethods
};
